import cn from 'classnames';
import React, { useEffect } from 'react';
import { LayoutDesktop } from '@alfa-bank/site-layout/desktop';

import { RenderedHeader } from '../../tabs-header/components/rendered-header';
import type { TPanelHeaderDesktopV2Props } from '../models';

import defaultStyles from './styles/styles.css';
import withIconStyles from './styles/with-icon.css';
import { useTabsPanelV2 } from './hooks/use-tabs-panel-v2';

export const PanelHeaderV2Desktop = (props: TPanelHeaderDesktopV2Props) => {
    const {
        className,
        dataTestId = 'TabsHeader',
        iconBackgroudColor = 'transparent',
        panelBackgroundColor,
        selectedID,
        theme = 'light',
        titles,
        widthTab = 'equal',
        widthTabPanel = 'fullBlock',
        withLayout = false,
    } = props;

    const {
        headerContainer,
        headerList,
        onTabMouseDownHandler,
        onTabMouseUpHandler,
        selectedTab,
        tabWidthList,
        tabsProps,
        withIcon,
    } = useTabsPanelV2(props);

    useEffect(() => {
        const selectedTabOffset = selectedTab.current?.offsetLeft ?? 0;
        const selectedTabWidth = selectedTab.current?.offsetWidth ?? 0;
        const headerListWidth = headerContainer.current?.offsetWidth ?? 0;

        headerContainer.current?.scroll({
            behavior: 'smooth',
            left:
                selectedTabOffset -
                Math.round(headerListWidth / 2) +
                Math.round(selectedTabWidth / 2),
        });
    }, [headerContainer, headerList, selectedID, selectedTab]);

    const renderComponent = (
        <div
            className={cn(
                defaultStyles.backCover,
                defaultStyles[theme as keyof typeof defaultStyles],
                defaultStyles[widthTabPanel],
                {
                    [defaultStyles.withIcon]: withIcon,
                }
            )}
            style={
                panelBackgroundColor && {
                    backgroundColor: panelBackgroundColor,
                }
            }
        >
            <RenderedHeader
                className={className}
                dataTestId={dataTestId}
                headerContainer={headerContainer}
                headerList={headerList}
                iconBackgroundColor={iconBackgroudColor}
                selectedID={selectedID}
                selectedTab={selectedTab}
                styles={withIcon ? { ...defaultStyles, ...withIconStyles } : defaultStyles}
                tabInlineStyle={
                    widthTab === 'equal'
                        ? { minWidth: `${tabWidthList.sort((a, b) => b - a)[0]}px` }
                        : undefined
                }
                titles={titles}
                {...tabsProps}
                onTabMouseDown={onTabMouseDownHandler}
                onTabMouseUp={onTabMouseUpHandler}
                translateX={0}
            />
        </div>
    );

    return <>{withLayout ? <LayoutDesktop>{renderComponent}</LayoutDesktop> : renderComponent}</>;
};
